import { Component, inject, input, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '@ubie/core';

@Component({
  selector: 'acl-activate-user',
  standalone: false,
  templateUrl: './activate-user.component.html',
  styleUrl: './activate-user.component.scss',
})
export class ActivateUserComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly userService = inject(UsersService);

  readonly key = input.required<string>();
  readonly isSuccess = signal(false);

  ngOnInit(): void {
    this.activateUser();
  }

  activateUser(): void {
    this.userService.activate(this.key(), null).subscribe({
      next: () => this.isSuccess.set(true),
      error: () => this.isSuccess.set(false),
    });
  }

  onToAppClicked(): void {
    this.router.navigate(['/dashboard']);
  }
}
